/* LUXURIA – Produktbild-Lightbox (alle Produkttemplates)
   Ersetzt beim Klick auf ein Produktbild das Theme-Modal durch eine kompakte Galerie:
   Bild vollständig sichtbar (contain), Pfeile, Tastatur, Wischen, Thumbnails, Zähler "2 / 7".
   Bilder und Reihenfolge stammen 1:1 aus der Theme-Galerie (Shopify-Produktmedien).
   Videos/3D-Modelle werden nicht abgefangen und öffnen wie bisher. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function sized(src, width) {
    if (!src) return src;
    if (/[?&]width=\d+/.test(src)) return src.replace(/([?&]width=)\d+/, '$1' + width);
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function collect(gallery) {
    var items = [];
    gallery.querySelectorAll('.product-media-main[data-media-id]').forEach(function (media) {
      var opener = media.querySelector('.product-modal-opener-image');
      var img = opener && opener.querySelector('img');
      if (!img) return;
      items.push({
        id: media.getAttribute('data-media-id'),
        src: img.getAttribute('src') || img.currentSrc,
        alt: img.getAttribute('alt') || '',
        width: parseInt(img.getAttribute('width'), 10) || 0,
        height: parseInt(img.getAttribute('height'), 10) || 0
      });
    });
    return items;
  }

  var ICON_PREV = '<svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg>';
  var ICON_NEXT = '<svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M9 6l6 6-6 6"/></svg>';
  var ICON_CLOSE = '<svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  var ICON_ZOOM = '<svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><circle cx="11" cy="11" r="6.5"/><path d="M20 20l-4.2-4.2M11 8.5v5M8.5 11h5"/></svg>';
  var ZOOM = 2.5;

  function Lightbox(gallery) {
    this.gallery = gallery;
    this.items = [];
    this.index = 0;
    this.root = null;
    this.lastFocus = null;
    this.onKey = this.onKey.bind(this);
  }

  Lightbox.prototype.build = function () {
    var root = document.createElement('div');
    root.className = 'lux-lb';
    root.hidden = true;
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-modal', 'true');
    root.setAttribute('aria-label', 'Produktbilder');
    root.innerHTML =
      '<div class="lux-lb__bar">' +
        '<span class="lux-lb__count" aria-live="polite"></span>' +
        '<span class="lux-lb__tools">' +
          '<button type="button" class="lux-lb__zoom" data-lb-zoom aria-pressed="false">' + ICON_ZOOM + '<span class="visually-hidden">Bild vergrößern</span></button>' +
          '<button type="button" class="lux-lb__close" data-lb-close>' + ICON_CLOSE + '<span class="visually-hidden">Galerie schließen</span></button>' +
        '</span>' +
      '</div>' +
      '<div class="lux-lb__stage" data-lb-stage>' +
        '<button type="button" class="lux-lb__nav lux-lb__nav--prev" data-lb-prev>' + ICON_PREV + '<span class="visually-hidden">Vorheriges Bild</span></button>' +
        '<figure class="lux-lb__figure"><img class="lux-lb__img" alt="" decoding="async" draggable="false"></figure>' +
        '<button type="button" class="lux-lb__nav lux-lb__nav--next" data-lb-next>' + ICON_NEXT + '<span class="visually-hidden">Nächstes Bild</span></button>' +
      '</div>' +
      '<div class="lux-lb__thumbs" data-lb-thumbs></div>';
    document.body.appendChild(root);
    this.root = root;
    this.img = root.querySelector('.lux-lb__img');
    this.count = root.querySelector('.lux-lb__count');
    this.stage = root.querySelector('[data-lb-stage]');
    this.thumbs = root.querySelector('[data-lb-thumbs]');

    var self = this;
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-lb-close]')) { self.close(); return; }
      if (e.target.closest('[data-lb-zoom]')) { self.toggleZoom(); return; }
      if (e.target.closest('[data-lb-prev]')) { self.go(self.index - 1); return; }
      if (e.target.closest('[data-lb-next]')) { self.go(self.index + 1); return; }
      var thumb = e.target.closest('[data-lb-index]');
      if (thumb) { self.go(+thumb.getAttribute('data-lb-index')); return; }
      // Klick auf freie Fläche neben dem Bild schließt (nicht direkt nach Ziehen, im Zoom beendet er nur den Zoom)
      if (self.justDragged) return;
      if (e.target === self.stage || e.target.classList.contains('lux-lb__figure')) {
        if (self.zoom > 1) self.resetZoom(); else self.close();
      }
    });
    this.bindSwipe();
  };

  /* Gesten: Wischen (Touch) blättert, Doppeltipp/Doppelklick zoomt, im Zoom verschiebt Ziehen das Bild */
  Lightbox.prototype.bindSwipe = function () {
    var self = this;
    var startX = null, startY = null, dx = 0, dy = 0, pointerId = null, panBase = null;
    var lastTap = 0, lastTapX = 0, lastTapY = 0;
    this.zoom = 1; this.tx = 0; this.ty = 0;

    this.stage.addEventListener('pointerdown', function (e) {
      if (e.target.closest('button')) return;
      if (self.zoom > 1) {
        pointerId = e.pointerId; startX = e.clientX; startY = e.clientY; dx = 0; dy = 0;
        panBase = { x: self.tx, y: self.ty };
        self.img.style.transition = 'none';
        return;
      }
      if (e.pointerType === 'mouse' || self.items.length < 2) return;
      startX = e.clientX; startY = e.clientY; dx = 0; dy = 0; pointerId = e.pointerId; panBase = null;
      self.img.style.transition = 'none';
    });
    this.stage.addEventListener('pointermove', function (e) {
      if (startX === null || e.pointerId !== pointerId) return;
      dx = e.clientX - startX;
      dy = e.clientY - startY;
      if (panBase) {
        self.setPan(panBase.x + dx, panBase.y + dy);
        return;
      }
      if (Math.abs(dx) > Math.abs(dy)) self.img.style.transform = 'translateX(' + dx + 'px)';
    });
    var end = function (e) {
      if (startX === null || (e && e.pointerId !== pointerId)) return;
      // Strecke auch aus dem Loslassen-Punkt bestimmen (falls keine pointermove-Events ankamen)
      if (e && e.type === 'pointerup' && !panBase) { dx = e.clientX - startX; dy = e.clientY - startY; }
      var wasPan = !!panBase, moved = dx, movedY = dy;
      startX = null; pointerId = null; panBase = null;
      if (Math.abs(moved) > 6 || Math.abs(movedY) > 6) {
        self.justDragged = true;
        setTimeout(function () { self.justDragged = false; }, 0);
      }
      self.img.style.transition = '';
      if (wasPan) return;
      // Doppeltipp hat gerade gezoomt (Listener am Bild läuft vor diesem) – Zoom-Transform nicht überschreiben
      if (self.zoom > 1) { self.applyZoom(); return; }
      self.img.style.transform = '';
      if (Math.abs(moved) > 50 && Math.abs(moved) > Math.abs(movedY)) self.go(self.index + (moved < 0 ? 1 : -1));
    };
    this.stage.addEventListener('pointerup', end);
    this.stage.addEventListener('pointercancel', end);

    // Doppeltipp (Touch) bzw. Doppelklick (Maus) auf dem Bild
    this.img.addEventListener('pointerup', function (e) {
      if (e.pointerType === 'mouse') return;
      var now = Date.now();
      if (now - lastTap < 320 && Math.abs(e.clientX - lastTapX) < 30 && Math.abs(e.clientY - lastTapY) < 30) {
        lastTap = 0;
        self.toggleZoom(e.clientX, e.clientY);
      } else {
        lastTap = now; lastTapX = e.clientX; lastTapY = e.clientY;
      }
    });
    this.img.addEventListener('dblclick', function (e) { self.toggleZoom(e.clientX, e.clientY); });
  };

  Lightbox.prototype.applyZoom = function () {
    var z = this.zoom;
    this.img.style.transform = z > 1 ? 'translate(' + this.tx + 'px,' + this.ty + 'px) scale(' + z + ')' : '';
    this.root.classList.toggle('is-zoomed', z > 1);
    this.stage.style.touchAction = z > 1 ? 'none' : '';
    var btn = this.root.querySelector('[data-lb-zoom]');
    btn.setAttribute('aria-pressed', z > 1 ? 'true' : 'false');
    btn.querySelector('.visually-hidden').textContent = z > 1 ? 'Zoom beenden' : 'Bild vergrößern';
  };

  // Verschiebung auf den Bildrand begrenzen
  Lightbox.prototype.setPan = function (x, y) {
    var w = this.img.offsetWidth, h = this.img.offsetHeight;
    var maxX = w * (this.zoom - 1) / 2, maxY = h * (this.zoom - 1) / 2;
    this.tx = Math.max(-maxX, Math.min(maxX, x));
    this.ty = Math.max(-maxY, Math.min(maxY, y));
    this.applyZoom();
  };

  Lightbox.prototype.toggleZoom = function (px, py) {
    if (this.zoom > 1) { this.resetZoom(); return; }
    this.zoom = ZOOM;
    // Größere Bildvariante anfordern, damit der Zoom scharf bleibt
    this.img.sizes = '250vw';
    var r = this.img.getBoundingClientRect();
    var cx = r.left + r.width / 2, cy = r.top + r.height / 2;
    var ox = (typeof px === 'number' ? px : cx) - cx, oy = (typeof py === 'number' ? py : cy) - cy;
    this.setPan(-ox * (ZOOM - 1), -oy * (ZOOM - 1));
  };

  Lightbox.prototype.resetZoom = function () {
    this.zoom = 1; this.tx = 0; this.ty = 0;
    if (this.img) {
      this.img.sizes = '(min-width: 990px) 80vw, 100vw';
      this.applyZoom();
    }
  };

  Lightbox.prototype.renderThumbs = function () {
    if (this.items.length < 2) { this.thumbs.hidden = true; return; }
    this.thumbs.hidden = false;
    this.thumbs.innerHTML = this.items.map(function (item, i) {
      return '<button type="button" class="lux-lb__thumb" data-lb-index="' + i + '">' +
        '<img src="' + sized(item.src, 160) + '" alt="" loading="lazy" width="80" height="80">' +
        '<span class="visually-hidden">Bild ' + (i + 1) + '</span></button>';
    }).join('');
  };

  Lightbox.prototype.open = function (startId) {
    this.items = collect(this.gallery);
    if (!this.items.length) return false;
    if (!this.root) this.build();
    var idx = 0;
    for (var i = 0; i < this.items.length; i++) if (this.items[i].id === startId) { idx = i; break; }
    this.lastFocus = document.activeElement;
    clearTimeout(this.hideTimer);
    this.resetZoom();
    this.renderThumbs();
    this.root.classList.toggle('is-single', this.items.length < 2);
    this.root.hidden = false;
    document.documentElement.classList.add('lux-lb-open');
    requestAnimationFrame(function () { this.root.classList.add('is-open'); }.bind(this));
    this.show(idx, true);
    document.addEventListener('keydown', this.onKey);
    this.root.querySelector('[data-lb-close]').focus();
    return true;
  };

  Lightbox.prototype.close = function () {
    if (!this.root || this.root.hidden) return;
    var self = this;
    this.root.classList.remove('is-open');
    document.documentElement.classList.remove('lux-lb-open');
    document.removeEventListener('keydown', this.onKey);
    this.resetZoom();
    clearTimeout(this.hideTimer);
    this.hideTimer = setTimeout(function () { self.root.hidden = true; }, reduceMotion ? 0 : 180);
    // Hauptbild der Seite auf das zuletzt angesehene Bild setzen (Theme-Thumbnail-Logik)
    var current = this.items[this.index];
    if (current && typeof this.gallery.setActiveMedia === 'function') {
      try { this.gallery.setActiveMedia(current.id, false); } catch (err) { /* Theme-Galerie unverändert lassen */ }
    }
    if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus({ preventScroll: true });
  };

  Lightbox.prototype.go = function (i) {
    var n = this.items.length;
    if (n < 2) return;
    this.show((i + n) % n, false);
  };

  Lightbox.prototype.show = function (i, instant) {
    var item = this.items[i];
    if (!item) return;
    this.index = i;
    if (this.zoom > 1) this.resetZoom();
    var img = this.img;
    var apply = function () {
      img.src = sized(item.src, 1600);
      img.srcset = [1000, 1600, 2400].map(function (w) { return sized(item.src, w) + ' ' + w + 'w'; }).join(', ');
      img.sizes = '(min-width: 990px) 80vw, 100vw';
      img.alt = item.alt;
      if (item.width && item.height) { img.width = item.width; img.height = item.height; }
    };
    if (instant || reduceMotion) {
      apply();
    } else {
      img.classList.add('is-switching');
      setTimeout(function () {
        apply();
        var done = function () { img.classList.remove('is-switching'); };
        if (img.complete) done(); else { img.onload = done; img.onerror = done; }
      }, 120);
    }
    this.count.textContent = (i + 1) + ' / ' + this.items.length;
    this.thumbs.querySelectorAll('[data-lb-index]').forEach(function (t, k) {
      if (k === i) {
        t.setAttribute('aria-current', 'true');
        if (t.scrollIntoView) t.scrollIntoView({ block: 'nearest', inline: 'center' });
      } else {
        t.removeAttribute('aria-current');
      }
    });
    // Nachbarbilder vorladen
    [i - 1, i + 1].forEach(function (k) {
      var nb = this.items[(k + this.items.length) % this.items.length];
      if (nb) { var pre = new Image(); pre.src = sized(nb.src, 1600); }
    }, this);
  };

  Lightbox.prototype.onKey = function (e) {
    if (e.key === 'Escape') { e.preventDefault(); this.close(); return; }
    if (e.key === 'ArrowRight') { e.preventDefault(); this.go(this.index + 1); return; }
    if (e.key === 'ArrowLeft') { e.preventDefault(); this.go(this.index - 1); return; }
    if (e.key === 'Tab') {
      var f = Array.prototype.slice.call(this.root.querySelectorAll('button')).filter(function (b) { return b.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  };

  /* ---------- Galerie auf der Seite ----------
     Wischen auf dem Hauptbild, Zähler "2 / 7", Pfeile (Desktop), weich gefüllte Ränder statt weißer Balken.
     Blättern nutzt die Theme-Funktion setActiveMedia – Bilder und Reihenfolge bleiben unverändert. */
  var swipedAt = 0;

  function enhancePage(gallery) {
    if (gallery.__luxPage) return;
    gallery.__luxPage = true;
    var wrapper = gallery.querySelector('.product-media-main-wrapper');
    if (!wrapper) return;
    var mains = Array.prototype.slice.call(wrapper.querySelectorAll('.product-media-main[data-media-id]'));

    // Ränder: dasselbe Foto stark weichgezeichnet hinter dem vollständig sichtbaren Bild
    mains.forEach(function (media) {
      var img = media.querySelector('.product-modal-opener-image img');
      var box = img && img.closest('.aspect-ratio');
      var src = img && (img.getAttribute('src') || '');
      if (box && src) {
        box.style.setProperty('--lux-fill', 'url("' + sized(src, 120).replace(/"/g, '%22') + '")');
        box.classList.add('lux-fill');
      }
    });

    if (mains.length < 2) return;
    wrapper.classList.add('lux-gallery-nav');

    var counter = document.createElement('span');
    counter.className = 'lux-gcount';
    counter.setAttribute('aria-hidden', 'true');
    var prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'lux-gnav lux-gnav--prev';
    prev.innerHTML = ICON_PREV + '<span class="visually-hidden">Vorheriges Bild</span>';
    var next = document.createElement('button');
    next.type = 'button';
    next.className = 'lux-gnav lux-gnav--next';
    next.innerHTML = ICON_NEXT + '<span class="visually-hidden">Nächstes Bild</span>';
    wrapper.appendChild(counter);
    wrapper.appendChild(prev);
    wrapper.appendChild(next);

    function activeIndex() {
      for (var i = 0; i < mains.length; i++) if (mains[i].classList.contains('is-active')) return i;
      return 0;
    }
    function update() { counter.textContent = (activeIndex() + 1) + ' / ' + mains.length; }
    function goTo(i) {
      var n = mains.length;
      var target = mains[(i + n) % n];
      try { gallery.setActiveMedia(target.getAttribute('data-media-id'), false); } catch (err) { return; }
      update();
    }
    update();
    new MutationObserver(update).observe(wrapper, { subtree: true, attributes: true, attributeFilter: ['class'] });
    prev.addEventListener('click', function () { goTo(activeIndex() - 1); });
    next.addEventListener('click', function () { goTo(activeIndex() + 1); });

    // Wischen (nur Touch/Stift): horizontale Geste blättert, vertikales Scrollen bleibt frei
    var sx = null, sy = null, pid = null;
    wrapper.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' || e.target.closest('.lux-gnav')) return;
      sx = e.clientX; sy = e.clientY; pid = e.pointerId;
    });
    var end = function (e) {
      if (sx === null || e.pointerId !== pid) return;
      var dx = e.clientX - sx, dy = e.clientY - sy;
      sx = null; pid = null;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.2) {
        swipedAt = Date.now();
        goTo(activeIndex() + (dx < 0 ? 1 : -1));
      }
    };
    wrapper.addEventListener('pointerup', end);
    wrapper.addEventListener('pointercancel', function () { sx = null; pid = null; });
  }

  function initPage() {
    document.querySelectorAll('.template-product media-gallery, .product-page-expanded media-gallery').forEach(enhancePage);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initPage);
  else initPage();
  document.addEventListener('shopify:section:load', initPage);

  var boxes = new WeakMap();

  // Klicks auf Produktbilder in der Capture-Phase abfangen, bevor das Theme-Modal öffnet
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('.product-modal-opener-image');
    if (!opener) return;
    // Direkt nach einer Wischgeste auf dem Hauptbild kein Öffnen der Lightbox
    if (Date.now() - swipedAt < 400) { e.preventDefault(); e.stopImmediatePropagation(); return; }
    var gallery = opener.closest('media-gallery');
    var media = opener.closest('.product-media-main[data-media-id]');
    if (!gallery || !media) return;
    var box = boxes.get(gallery);
    if (!box) { box = new Lightbox(gallery); boxes.set(gallery, box); }
    if (box.open(media.getAttribute('data-media-id'))) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  }, true);
})();
